/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Auth0AccountRole } from "./Auth0AccountRole";

/**
 * What happened for one recipient.
 */
export type TemplateSendResult = {
  person_type: Auth0AccountRole;
  person_id: number;
  name: string;
  status: TemplateSendResult.status;
  reason?: string | null;
};

export namespace TemplateSendResult {
  export enum status {
    SENT = "sent",
    SKIPPED = "skipped",
    FAILED = "failed",
  }
}
